import React from 'react';
import { Box, Typography, Grid, CircularProgress, Alert } from '@mui/material';
import PrescriptionCard from '../PrescriptionCard/PrescriptionCard';
import PropTypes from 'prop-types';

const PrescriptionList = ({ 
  prescriptions = [], 
  loading = false, 
  error = null, 
  onSelectPrescription, 
  onClaimPrescription, 
  onIssuePrescription,
  isClaimed = false,
  isIssued = false,
  emptyMessage = "No prescriptions found" 
}) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    );
  }

  if (!prescriptions || prescriptions.length === 0) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          {emptyMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {prescriptions.map((prescription) => (
        <Grid item xs={12} sm={6} md={4} key={prescription.requestId}>
          <PrescriptionCard 
            prescription={prescription}
            onSelect={() => onSelectPrescription && onSelectPrescription(prescription)}
            onClaim={() => onClaimPrescription && onClaimPrescription(prescription.requestId)}
            onIssue={() => onIssuePrescription && onIssuePrescription(prescription.requestId)}
            isClaimed={isClaimed}
            isIssued={isIssued}
          />
        </Grid>
      ))}
    </Grid>
  );
};

PrescriptionList.propTypes = {
  prescriptions: PropTypes.array.isRequired,
  onSelectPrescription: PropTypes.func,
  onClaimPrescription: PropTypes.func,
  onIssuePrescription: PropTypes.func,
  isClaimed: PropTypes.bool,
  isIssued: PropTypes.bool,
  emptyMessage: PropTypes.string
};

PrescriptionList.defaultProps = {
  emptyMessage: 'No prescriptions found'
};

export default PrescriptionList; 